import React from 'react';
import imagePath from '../../assets/boton_listo_muchas_gracias.png';
import { useTutoresModel } from '../../modelos/Tutores/modeloTutores';
import { useUsers } from '../../metodos/userContext';

// Ruta a tu imagen en la carpeta `public/images/`

const CuentaInactiva = () => {
    const {
        usuario
    } = useUsers()

    const {
        updateTutor,
    } = useTutoresModel();

  const handleActivate = async() => {
    await updateTutor(usuario.uid,'DUFY ASESORIAS','activo',true,'field');
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-100 font-sans p-4">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-lg text-center">
        
        <h1 className="text-3xl font-bold text-gray-800">
          Tu cuenta está inactiva
        </h1>

        <p className="text-gray-600">
          Esto puede ocurrir por no responder a nuestras notificaciones en WhatsApp.
        </p>

        {/* Sección de Consecuencias */}
        <div className="text-left bg-red-50 border border-red-200 p-4 rounded-lg space-y-3">
          <h2 className="font-semibold text-red-800">Al estar inactiva:</h2>
          <ul className="space-y-2 text-red-700 text-sm">
            <li className="flex items-start">
              {/* Ícono de campana tachada */}
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.586 15.586A2 2 0 0113.172 13H11a2 2 0 01-1.414-.586l-3-3a2 2 0 01.001-2.828l3-3a2 2 0 012.828 0l3 3a2 2 0 01.586 1.414V11m-3.586 4.586H12m3.414-4.586a2 2 0 00-2.828 0l-3 3a2 2 0 000 2.828l3 3a2 2 0 002.828 0l.001-.001M18.364 5.636l-12.728 12.728" />
              </svg>
              <span>No recibirás notificaciones importantes.</span>
            </li>
            <li className="flex items-start">
              {/* Ícono de documento bloqueado */}
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2zM15 12H9m6 4H9" />
              </svg>
              <span>No podrás cotizar en las solicitudes de servicio.</span>
            </li>
          </ul>
        </div>

        <div className="flex justify-center pt-2">
          <img
            src={imagePath}
            alt="Botón 'Listo Muchas Gracias' de WhatsApp"
            className="max-w-xs w-full h-auto rounded-lg border shadow-sm"
          />
        </div>
        
        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-md text-left">
          <p className="font-semibold text-amber-800">¡Importante!</p>
          <p className="text-amber-700 text-sm mt-1">
            Cada <strong>24 horas</strong> recibirás una notificación. Para mantener tu cuenta activa, te recomendamos oprimir el botón <strong>"LISTO MUCHAS GRACIAS"</strong>.
          </p>
        </div>

        <button
          onClick={handleActivate}
          className="w-full px-6 py-3 text-lg font-semibold text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-transform transform hover:scale-105"
        >
          Activar mi cuenta
        </button>

      </div>
    </div>
  );

};

export default CuentaInactiva;